import { createSpotlight } from '@mantine/spotlight';

export const [spotlightStore, spotlightHandle] = createSpotlight();

export function spotlightSelectFirst(): void {
    const state = spotlightStore.getState();
    const list = state.listId ? document.getElementById(state.listId) : null;
    if (!list) return;

    list.querySelector('[data-selected]')?.removeAttribute('data-selected');
    const first = list.querySelector<HTMLElement>('[data-action]');

    if (!first) {
        spotlightStore.updateState((current) => ({ ...current, selected: -1 }));
        return;
    }

    first.setAttribute('data-selected', 'true');
    first.scrollIntoView({ block: 'nearest' });
    spotlightStore.updateState((current) => ({ ...current, selected: 0 }));
}
